import Phaser from 'phaser';
import { COLORS, GAME_HEIGHT, GAME_WIDTH } from '../config/constants';

export class AdPlaceholderScene extends Phaser.Scene {
  private complete!: () => void;
  private completed = false;

  constructor() {
    super('AdPlaceholder');
  }

  init(data: { complete: () => void }): void {
    this.complete = data.complete;
    this.completed = false;
  }

  create(): void {
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0.82);
    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'ui_panel');

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 105, 'Advertisement', {
        fontFamily: 'Georgia, serif',
        fontSize: '36px',
        color: '#ffffff'
      })
      .setOrigin(0.5);

    this.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 10, 390, 105, 0x252231, 1)
      .setStrokeStyle(3, COLORS.fusionGold);
    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 20, 'Google H5 Games Ads\nplaceholder', {
        fontFamily: 'Arial',
        fontSize: '25px',
        align: 'center',
        color: '#ffffff'
      })
      .setOrigin(0.5);
    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 58, 'No ad request is sent in this build.', {
        fontFamily: 'Arial',
        fontSize: '16px',
        color: '#cccccc'
      })
      .setOrigin(0.5);

    const button = this.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 112, 190, 52, COLORS.fusionGold, 1)
      .setStrokeStyle(3, COLORS.outline)
      .setInteractive({ useHandCursor: true });
    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 112, 'Continue', {
        fontFamily: 'Arial',
        fontSize: '22px',
        color: '#2e2a38',
        fontStyle: 'bold'
      })
      .setOrigin(0.5);

    button.on('pointerdown', () => this.finish());
    this.input.keyboard?.once('keydown-ENTER', () => this.finish());
    this.input.keyboard?.once('keydown-ESC', () => this.finish());
  }

  private finish(): void {
    if (this.completed) return;
    this.completed = true;
    this.scene.stop();
    this.complete();
  }
}
